import { Redirect, Route, Switch } from 'react-router-dom';

import { useFeatureDetails } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';

import TalentReviewGroup from './TalentReviewGroup';
import TalentReviewSnapshotPage from './TalentReviewSnapshotPage';
import TalentReviews from './TalentReviews';
import useTalentReviewPath from './hooks/useTalentReviewPath';
import TalentReviewTemplatePage from './templates/TalentReviewTemplatePage';

export enum TalentReviewV2Route {
	Root = '/talent-reviews/v2',
	Groups = '/talent-reviews/v2/groups',
	NewTemplate = '/talent-reviews/v2/templates/new',
	EditTemplate = '/talent-reviews/v2/templates/:id',
	Snapshot = '/talent-reviews/v2/snapshots/:snapshotID',
	Grid = '/talent-reviews/v2/groups/:groupID/:templateID/:localDate?',
	Group = '/talent-reviews/v2/groups/:groupID',
}

export default function TalentReviewV2Routes() {
	const path = useTalentReviewPath();
	const talentReviewsV2 = useFeatureDetails(graphql.FeatureName.TalentReviewsV2);

	if (talentReviewsV2.loading) {
		return null;
	}

	if (!talentReviewsV2.available) {
		return <Redirect to="/talent-reviews" />;
	}

	return (
		<Switch>
			<Redirect exact path={TalentReviewV2Route.Root} to={TalentReviewV2Route.Groups} />
			<Route exact path={TalentReviewV2Route.Groups}>
				<TalentReviews />
			</Route>
			<Route exact path={TalentReviewV2Route.NewTemplate}>
				<TalentReviewTemplatePage />
			</Route>
			<Route exact path={TalentReviewV2Route.EditTemplate}>
				{({ match }) => match && <TalentReviewTemplatePage id={match.params.id} />}
			</Route>
			<Route exact path={TalentReviewV2Route.Snapshot}>
				{({ match }) => match && <TalentReviewSnapshotPage snapshotID={match.params.snapshotID} />}
			</Route>
			<Route path={TalentReviewV2Route.Grid}>
				{({ match }) =>
					match && (
						<TalentReviewGroup
							groupID={match.params.groupID}
							templateID={match.params.templateID}
							localDate={match.params.localDate}
						/>
					)
				}
			</Route>
			<Route exact path={TalentReviewV2Route.Group}>
				{({ match }) => match && <TalentReviewGroup groupID={match.params.groupID} />}
			</Route>
			<Route path="/talent-reviews/v2/:templateID/:groupID/:localDate?">
				{({ match, location }) =>
					match && (
						<Redirect
							to={path({
								groupID: match.params.groupID,
								templateID: match.params.templateID,
								localDate: match.params.localDate,
								search: location.search,
							})}
						/>
					)
				}
			</Route>
		</Switch>
	);
}
